import type { Subscription } from 'rxjs/Subscription';
import type { ErrorResponse } from '@atlassian/jira-servicedesk-common/src/utils/fetch';
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import type {
	TicketTypesRestResponse,
	GroupWithTicketTypeIds,
	PracticeWithTicketTypeIds,
} from '../../../../common/types';
import getTicketTypesRest from '../../../get-ticket-types';
import type { ImmutableState, ContainerProps } from '../../types';
import type { ActionCallback } from '../types';
import { toTicketTypesMap } from './utils';

type CallbackResult = {
	groups: GroupWithTicketTypeIds[];
	practices: PracticeWithTicketTypeIds[];
};

const getTicketTypes =
	(callback: ActionCallback<CallbackResult>) =>
	(
		{ getState, setState }: StoreActionApi<ImmutableState>,
		{ projectId, activeStreams }: ContainerProps,
	): Subscription => {
		const subscription = getTicketTypesRest(projectId).subscribe(
			({ ticketTypes, groups, practices }: TicketTypesRestResponse) => {
				setState({
					...getState(),
					ticketTypes: {
						data: toTicketTypesMap(ticketTypes),
						loading: false,
						error: null,
					},
				});
				callback({ groups, practices });
			},
			(error: ErrorResponse) => {
				setState({
					...getState(),
					ticketTypes: { data: {}, loading: false, error },
				});
				callback(undefined, error);
			},
		);

		activeStreams && activeStreams.add(subscription);

		return subscription;
	};

export default getTicketTypes;
